import { render, staticRenderFns } from "./DefaultSiteNews.vue?vue&type=template&id=28660a50&scoped=true&"
import script from "./DefaultSiteNews.vue?vue&type=script&lang=js&"
export * from "./DefaultSiteNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28660a50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
